import React from 'react';

import { Thumbnail, type ThumbnailProps } from '@pkg/components';

import { NftAssetButton, NftAssetStatic, ThumnailWrapper } from './styles';

// Consider pulling in the `autoPlay` prop as well.
export interface NftAssetProps extends Pick<ThumbnailProps, 'id' | 'title' | 'videoUrl' | 'imageUrl' | 'mashWidth'> {
    onAction?(): void;
}

export function NftAsset({ onAction, ...thumbnailProps }: NftAssetProps) {
    const contentMarkup = (
        <ThumnailWrapper>
            <Thumbnail {...thumbnailProps} autoPlay />
        </ThumnailWrapper>
    );

    return onAction ? (
        <NftAssetButton onClick={onAction}>{contentMarkup}</NftAssetButton>
    ) : (
        <NftAssetStatic>{contentMarkup}</NftAssetStatic>
    );
}
